import React from 'react'

import { Stack } from '@mui/material'
import Link from 'next/link'
import { Text4 } from '../styleds'

const GoToHdWallet = () => {
  return (
    <Stack direction="row" sx={{ mt: 32 }}>
      <Text4 sx={{ opacity: 0.7 }}>I don&apos;t have a wallet plug-in,</Text4>&nbsp;
      <Link target="_blank" href={'https://app-hd.multibit.exchange/'}>
        <Text4 sx={{ color: '#bfff0b' }}>HD Wallet Mode →</Text4>
      </Link>
    </Stack>
  )
}

export default GoToHdWallet
